const personalisation_code = document.getElementById('personalisation_code').value;
const personalisation_file = personalisation_code.toLowerCase();
async function personalisationImage(filename) {
    const figure = document.querySelector('.main-cover-image');
    try {
      const canvas = await html2canvas(figure, {
        useCORS: true,
        backgroundColor: null,
        scale: 2
      });

      const dataURL = canvas.toDataURL("image/png");
      const base64String = dataURL.replace(/^data:image\/png;base64,/, "");

      await fetch("https://dashboard-imn0.onrender.com/shopify/upload-file", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer sk_prod_b178a7e765ac0e79dac5a1e5f0ac9e8c71310e317c053c93"
        },
        body: JSON.stringify({
          brand_key: "TMC",
          filename: filename,
          file_data: base64String
        })
      });
    } catch (err) {
      console.error("Error generating or uploading image:", err);
    }
}

function createBundleId() { return "b_" + Date.now() + Math.floor(Math.random() * 100000); }

document.querySelector('.message-select').addEventListener('change', function () {
    const selectedOption = this.options[this.selectedIndex];
    document.querySelector('textarea.message').disabled = false;
    document.querySelector('textarea.heading').disabled = false;
    document.querySelector('.message').value = selectedOption.dataset.message || '';
    document.querySelector('.heading').value = selectedOption.value || '';
    document.querySelector('.person-image').src = selectedOption.dataset.image || '//www.themancompany.com/cdn/shop/files/cyob_lifestyle_black_box4_1_256x256_cdc67c2a-32c6-4eb0-9045-0e6092680ca2.jpg?v=1724058897';
    let message = `<div class="custom-msg-wrap">
            <p id="customMsg" class="custom-msg">${ selectedOption.dataset.message || ''}</p>
            <p id="customTitle" class="custom-title">${ selectedOption.value || ''}</p>
          </div>`;
    document.querySelector('.main-cover-image').innerHTML = message;
    (selectedOption.value != '')?document.querySelector('.main-cover-image').classList.remove('hide'):document.querySelector('.main-cover-image').classList.add('hide');

    const submitBtn = document.getElementById("submitBundleBox");
    submitBtn.disabled = (selectedOption.value != '')?false:true;
});

document.getElementById("personalisationMessage").addEventListener("input", function () {
    document.getElementById("customMsg").textContent = this.value;
});

document.getElementById("personalisationTitle").addEventListener("input", function () {
    document.getElementById("customTitle").textContent = this.value;
});

document.getElementById("card")?.addEventListener("change", function() {
    const submitBtn = document.getElementById("submitBundleBox");
    const messageInput = document.querySelector(".message");
    submitBtn.disabled = this.checked && messageInput.value.trim() === "";

});

const fileInput = document.getElementById("input-file");
fileInput.addEventListener("change", function () {
      const file = this.files[0];
      if (!file) return;
      document.getElementById("input-placeholder").innerText = file.name;
      const url = URL.createObjectURL(file);
      const img = document.createElement("img");
      img.src = url;
      img.alt = "Uploaded Image";
      img.style.width = "140px";
      img.style.height = "140px";
      img.style.borderRadius = "5px";
      img.style.marginBottom = "10px";
      document.querySelector('.main-cover-image').appendChild(img);
});

const chk1 = document.getElementById('card');
const chk2 = document.getElementById('giftwrap');
const person_img = document.querySelector('.person-image');
const covImg = document.querySelector('.main-cover-image');

  
function updateImage() {
    if (chk1.checked && chk2.checked) {
      if(document.querySelector('.message-select').value != "") {
        covImg.classList.remove('hide');
        person_img.src = person_img.dataset.cardImage;
      }
    } else if (chk1.checked) {
      if(document.querySelector('.message-select').value != "") {
        covImg.classList.remove('hide');
        person_img.src = person_img.dataset.cardImage;
      }
    } else if (chk2.checked) {
      person_img.src = chk2.dataset.image;
      covImg.classList.add('hide')
    } else {
      person_img.src = person_img.dataset.image;
    }
  }
  chk1.addEventListener('change', updateImage);
  chk2.addEventListener('change', updateImage);

$(document).ready(function () {
  $("input[type='checkbox']").prop("disabled", false);

  $(window).on("beforeunload", function () {
    $(window).scrollTop(0);
  });
  
  $(".tab").click(function () {
    let tabId = $(this).attr("data-id");

    $(".tab-content").removeClass("active-tab-content");
    $(`.tab-content[data-id='${tabId}']`).addClass("active-tab-content");

    $(".tab").removeClass("active-tab");
    $(this).addClass("active-tab");

    $("#searchbar").val("").trigger("keyup");
    $("html, body").animate({ scrollTop: 0 }, 500);
  });
  
  $(window).scroll(function () {
    let height = $(window).height();
    let scroll = $(window).scrollTop();
    $(".sticky-header").toggleClass("show", scroll > height);
  });
  
  function imageUpdate() {
    let $slots = $("#tab_images li");
    $slots.find("img")
      .attr("src", "")
      .removeAttr("data-product-id data-tab-id");

    let index = 0;

    $("#flexi-box-form .product-checkbox:checked").each(function () {
      let imgUrl = $(this).data("img");
      let productId = $(this).data("product-id");
      let tabId = $(this).data("id-products").split("_")[1];
      let qty = parseInt($(this).closest(".product-info").find(".quantity-input").val()) || 1;

      for (let i = 0; i < qty; i++) {
        if (index < $slots.length) {
          $slots.eq(index).find("img")
            .attr("src", imgUrl)
            .attr("data-product-id", productId)
            .attr("data-tab-id", tabId);
          index++;
        }
      }
    });
  }

  function listAdd() {
      let totalPrice = 0;
      let update_price = 0;
      
      $("#bundle_submit input[name^='properties[sub_item_']").remove();
      $("#bundle_submit input[name='properties[uniware_items]']").remove();

      $("#flexi-box-form")
         .find(".product-checkbox:checked")
         .each(function () {
            let quantity =
               parseInt($(this).closest(".product-info").find(".quantity-input").val()) || 1;
            let bundleParts = $(this).attr("data-bundle").split("/");
            totalPrice += parseFloat(bundleParts[1]) * quantity;
         });

      let items = 0;
      let productData = { properties: { uniware_items: { items: [] } } };

      let $parentbox = $("#parentSKU");

      let itemObjParent = {
         id: $parentbox.data("store-id") || "",
         quantity: 1,
         varint_title: $parentbox.data("variant-title") || "",
         origin_location: "",
         fulfillment_status: "",
         total_discount: "",
         gift_card: "",
         requires_shipping: "",
         total_discount_set: "",
         title: $parentbox.data("product-name"),
         variant_id: $parentbox.data("variant-id") || "",
         tax_lines: "",
         mrp: "",
         price: 0,
         grams: "",
         sku: $parentbox.data("sku") || "",
         vendor: $parentbox.data("vendor") || "",
         product_id: $parentbox.data("product-id") || "",
         currency_code: "INR",
         fulfillable_quantity: "",
         fulfillment_service: "",
         taxable: "",
         discount_allocations: "",
         name: $parentbox.data("product-name") || "",
         price_set: "",
         properties: '{"_product":"parent"}',
         duties: ""
      };
      productData.properties.uniware_items.items.push(itemObjParent);
      let child_property = '{"_type":"child","_bid":"'+ personalisation_code +'}';
      $("#flexi-box-form")
         .find(".product-checkbox:checked")
         .each(function () {
            let $checkbox = $(this);
            let productValue = $checkbox.val();
            let productName = $checkbox.attr("name") || "";

            if (
               !productValue ||
               productValue.toLowerCase() === "no" ||
               productValue.toLowerCase().includes("hidden") ||
               productName.toLowerCase().includes("hidden")
            ) {
               $checkbox.prop("disabled", true);
               return;
            }

            let bundle = $checkbox.attr("data-bundle") || "";
            let quantity =
               parseInt($checkbox.closest(".product-info").find(".quantity-input").val()) || 1;

            let originalValue =
               $checkbox.attr("data-original-value") ||
               productValue.split(" (Qty:")[0];
            $checkbox.attr("data-original-value", originalValue);

            let productProperty = originalValue;
            if (quantity > 1) productProperty += ` (Qty: ${quantity})`;

            $checkbox.attr("name", "properties[Item " + items + "]");
            $checkbox.val(productProperty);

            let bundleParts = bundle.split("/");
            update_price =
               (parseFloat(bundleParts[1]) * quantity / totalPrice) *
               $checkbox.data("bundle-price");
            let sub_sku = $checkbox.data("sku") || "";
            let sub_img = $checkbox.data("img_name") || "";
            
            let itemObj = {
               id: $checkbox.data("store-id") || "",
               quantity: quantity,
               varint_title: $checkbox.data("variant-title") || "",
               origin_location: "",
               fulfillment_status: "",
               total_discount: "",
               gift_card: "",
               requires_shipping: "",
               total_discount_set: "",
               title: originalValue,
               variant_id: $checkbox.data("variant-id") || "",
               tax_lines: "",
               mrp: "",
               price: update_price.toFixed(2) || $checkbox.data("price") || "",
               grams: "",
               sku: sub_sku,
               vendor: $checkbox.data("vendor") || "",
               product_id: $checkbox.data("product-id") || "",
               currency_code: "INR",
               fulfillable_quantity: "",
               fulfillment_service: "",
               taxable: "",
               discount_allocations: "",
               name: $checkbox.data("product-name") || "",
               price_set: "",
               properties: child_property,
               duties: ""
            };
            let item_index = items + 1;
            let subItemLabel = `sub_item_${item_index}`;
            let subItemValue = `${originalValue} x ${quantity} :: ${sub_img}`;
            $("<input>")
               .attr("type", "hidden")
               .attr("name", `properties[${subItemLabel}]`)
               .val(subItemValue)
               .appendTo("#bundle_submit");
            productData.properties.uniware_items.items.push(itemObj);
            items++;
         });

      // Convert to JSON string
      productData.properties.uniware_items = JSON.stringify(
         productData.properties.uniware_items
      );

      // Add main uniware JSON
      $("<input>")
         .attr("type", "hidden")
         .attr("name", "properties[uniware_items]")
         .val(productData.properties.uniware_items)
         .appendTo("#bundle_submit");
  }
  let checkboxes = $("input[type='checkbox']");

  /* ---- QUANTITY HELPERS ---- */
  function updateQuantity(input, change) {
    let current = parseInt(input.val()) || 1;
    let min = parseInt(input.attr("min")) || 1;
    let max = parseInt(input.attr("max")) || 999;

    let next = current + change;
    if (next >= min && next <= max) {
      input.val(next);
      input.closest(".product-info").find(".product_counter").text(next);
    }
  }

  function getTotalSelectedQuantityInTab(tabId) {
    let total = 0;
    $(`.tab-content[data-id="tab${tabId}"] .product-checkbox:checked`).each(function () {
      let qty = parseInt($(this).closest(".product-info").find(".quantity-input").val()) || 1;
      total += qty;
    });
    return total;
  }

  /* ---- TAB COUNT UPDATE ---- */
  function updateTabCounts(tabId) {
    let $tabContent = $(`.tab-content[data-id="tab${tabId}"]`);
    let limit = parseInt($tabContent.data("product-limit"));
    let total = getTotalSelectedQuantityInTab(tabId);

    imageUpdate();

    let counterId = `#checkbox_count_tab_${tabId}_product`;

    if (total === limit) {
      $(counterId).show().html("&#10004;");
      $tabContent.find(".product-checkbox:not(:checked)").prop("disabled", true)
        .closest(".add-to-box").addClass("disables");
    } else if (total > 0) {
      $(counterId).show().text(total);
      $tabContent.find(".product-checkbox").prop("disabled", false)
        .closest(".add-to-box").removeClass("disables");
    } else {
      $(counterId).hide();
      $tabContent.find(".product-checkbox").prop("disabled", false)
        .closest(".add-to-box").removeClass("disables");
    }

    checkSubmitButtonVisibility();

    if (total === limit) {
      let nextTab = `tab${parseInt(tabId) + 1}`;
      if ($(`.tab[data-id="${nextTab}"]`).length) {
        setTimeout(() => $(`.tab[data-id="${nextTab}"]`).click(), 400);
      }
    }
  }

  /* --- SUBMIT BUTTON ENABLE ---- */
  function checkSubmitButtonVisibility() {
    let total = 0;
    $(".tab-content").each(function () {
      let tabId = $(this).data("id").replace("tab", "");
      total += getTotalSelectedQuantityInTab(tabId);
    });

    const _checkbox = document.getElementById("card");
    const _messageSelect = document.querySelector(".message-select");

    // const isEnabled = total === totalproductSelection;
    const isCheckboxChecked = _checkbox ? _checkbox?.checked : false;
    const isMessageSelected = _messageSelect && _messageSelect.value !== "";

    const isEnabled =
      total === totalproductSelection &&
      (!isCheckboxChecked || isMessageSelected);

    $("#submitBundleBox").prop("disabled", !isEnabled);
    if (total === totalproductSelection) { listAdd(); }
  }

  function submitAddForm(items, image_file) {
      fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items })
      })
      .then(response => response.json())
      .then(data => {
        const spinner = document.getElementById('bundleLoading');
        if (spinner) { spinner.classList.add('hidden'); }
        $("#submitBundleBox").prop("disabled", true);
        (image_file != '')?personalisationImage(`${personalisation_file}.png`):'';
        /*
          fetch('/?sections=cart-drawer,cart-icon-bubble')
          .then(res => res.json())
          .then(sections => {
            let cartHtml = sections['cart-drawer'];
            let tempDiv = document.createElement('div');
            tempDiv.innerHTML = cartHtml;
            let drawerInner = tempDiv.querySelector('.drawer__inner');
            document.querySelector('cart-drawer .drawer__inner').innerHTML = drawerInner.innerHTML;
            const drawer = document.querySelector('cart-drawer');
            if (drawer?.classList.contains('is-empty')) { drawer.classList.remove('is-empty'); }

            // console.log(drawerInner.innerHTML);
            const bubble = document.querySelector('#cart-icon-bubble');
            if (bubble) { bubble.innerHTML = sections['cart-icon-bubble']; }
            const cartIcon = document.querySelector('#cart-icon-bubble a, #cart-icon-bubble');
            if (cartIcon) { cartIcon.click(); }
          }); */
      })
      .catch(err => console.error("Error:", err));
  }

  /* ---- QUANTITY BUTTONS ---- */
  $(document).on("click", ".quantity-plus", function (e) {
    e.preventDefault();
    let input = $(this).siblings(".quantity-input");
    let tabId = parseInt(input.data("tab-index"));

    updateQuantity(input, 1);
    updateTabCounts(tabId);
  });

  $(document).on("click", ".quantity-minus", function (e) {
    e.preventDefault();
    let input = $(this).siblings(".quantity-input");
    let tabId = parseInt(input.data("tab-index"));

    updateQuantity(input, -1);
    updateTabCounts(tabId);
  });

  /* ---- CHECKBOX CLICK ----- */
  $(document).on("click", ".product-checkbox", function () {
    let tabId = Number($(this).data("id-products").split("_")[1]);
    let $product = $(this).closest(".product-info");

    if ($(this).is(":checked")) {
      $product.find(".quantity-selector").show();
      $product.find(".added_to_cart, .product_counter").removeClass("_hidden");
      $product.find(".quantity-input").val(1);
      $product.find(".product_counter").text(1);
    } else {
      $product.find(".quantity-selector").hide();
      $product.find(".added_to_cart, .product_counter").addClass("_hidden");
      $product.find(".quantity-input").val(1);
    }

    updateTabCounts(tabId);
  });

  /* ----- IMAGE REMOVE (FIXED) ---- */
  $("#tab_images").on("click", ".remove-img", function (e) {
      e.preventDefault();
      e.stopPropagation();

      let $img = $(this).siblings("img");
      let productId = $img.data("product-id");
      let tabId = parseInt($img.data("tab-id"));

      if (!productId || !tabId) return;

      let $checkbox = $(`.product-checkbox[data-product-id="${productId}"]`);
      if (!$checkbox.length) return;

      let $product = $checkbox.closest(".product-info");
      let $qtyInput = $product.find(".quantity-input");
      let qty = parseInt($qtyInput.val()) || 1;

      if (qty > 1) {
         qty--;
         $qtyInput.val(qty);
         $product.find(".product_counter").text(qty);
      } else {
         $checkbox.prop("checked", false);
         $qtyInput.val(1);
         $product.find(".quantity-selector").hide();
         $product.find(".added_to_cart, .product_counter").addClass("_hidden");
      }

      // ✅ Update tab state
      updateTabCounts(tabId);

      // ✅ SWITCH TO THE TAB FROM WHICH ITEM WAS REMOVED
      let $targetTab = $(`.tab[data-id="tab${tabId}"]`);
      if ($targetTab.length) {
         $(".tab").removeClass("active-tab");
         $(".tab-content").removeClass("active-tab-content");

         $targetTab.addClass("active-tab");
         $(`.tab-content[data-id="tab${tabId}"]`).addClass("active-tab-content");

         $("html, body").animate({ scrollTop: 0 }, 400);
      }
  });

  /* ---- SEARCH ----- */
  $("#searchbar").on("keyup", function () {
    let value = $(this).val().toLowerCase();
    $("#collection-list li").each(function () {
      $(this).toggle($(this).text().toLowerCase().includes(value));
    });
  });

  $(".search-clear").click(function () {
    $("#searchbar").val("").trigger("keyup");
  });

  $(document).on("click", "#submitBundleBox", function (e) {
       e.preventDefault();
       const spinner = this.querySelector('.loading__spinner');
        spinner?.classList.remove('hidden');
       let image_file = '';
       let productItems = [];
       
       let variant = $("#bundle_submit input[name='id']").val() || "";
       let props = {
          custom_flag: "flexibox",
          byob: true
       };

       $("#bundle_submit input[name^='properties[sub_item_']").each(function () {
          let name = $(this).attr("name").replace("properties[", "").replace("]", "");
          props[name] = $(this).val();
       });

       const $uniwareInput = $("#bundle_submit input[name='properties[uniware_items]']");
       let uniwareData = { items: [] };
       uniwareData = JSON.parse($uniwareInput.val());

       $("#flexi-box-form").find(".personalise-checkbox:checked")
         .each(function () {
            let property = '{"_type":"child","_bid":"'+ personalisation_code +'}';
            let $checkbox = $(this);
            const giftcardCheck = document.querySelector(".message-select").value;

            if($checkbox.attr("name") == 'giftwrap' && giftcardCheck != "") {            
                image_file = `https://cdn.shopify.com/s/files/1/1188/2592/files/${personalisation_file}.png`;
            }
            else if($checkbox.attr("name") == 'box_product' && image_file != '') {
                property = '{"_type":"master","_bid":"'+ personalisation_code +'","_image":"'+ image_file +'"}';
            }

            let itemObjUpdate = {
               id: $checkbox.data("store-id") || "",
               quantity: 1,
               varint_title: $checkbox.data("variant-title") || "",
               origin_location: "",
               fulfillment_status: "",
               total_discount: "",
               gift_card: "",
               requires_shipping: "",
               total_discount_set: "",
               title: $checkbox.data("product-name"),
               variant_id: $checkbox.data("variant-id") || "",
               tax_lines: "",
               mrp: "",
               price: 0,
               grams: "",
               sku: $checkbox.data("sku") || "",
               vendor: "TMC",
               product_id: $checkbox.data("product-id") || "",
               currency_code: "INR",
               fulfillable_quantity: "",
               fulfillment_service: "",
               taxable: "",
               discount_allocations: "",
               name: $checkbox.data("product-name") || "",
               price_set: "",
               properties: property,
               duties: ""
            };
            uniwareData.items.push(itemObjUpdate);
         });

        const uniwareString = JSON.stringify(uniwareData);
        props["uniware_items"] = uniwareString;
        if(image_file != '') {
          props["_image"] = image_file;
        }

       productItems.push({
          id: variant,
          quantity: 1,
          properties: props
       });

       if(image_file != '') {
        productItems.push({
          id: document.getElementById('box_product').value,
          quantity: 1,
          properties: {
            _image: image_file,
            _bid: personalisation_code
          }
        });
       }

       if (productItems.length) {
          (e.target.dataset.formtype) ? onBuyNowClick(e, false, productItems) : submitAddForm(productItems, image_file);
       }
       if(e.target.dataset.formtype) {
        const spinner = document.getElementById('bundleLoading');
        spinner?.classList.add('hidden');
        $("#submitBundleBox").prop("disabled", true);
        personalisationImage(`${personalisation_file}.png`);
       }
  });
});